<div class="p-4 overflow-auto h-[85vh]">

     <div class="flex justify-between items-center mb-3 -mt-5 w-full">
<!-- LEFT SIDE: TITLE -->
  <div>
    <h3 class="m-0 text-xl font-semibold">Client Packages</h3>
    <p class="text-gray-500 text-sm mt-1">Manage Client Packages</p>
  </div>

  <!-- RIGHT SIDE: CLIENT FILTER + SEARCH + BUTTON -->
  <div class="flex items-center gap-3">

    <!-- EXISTING CLIENT DROPDOWN FILTER -->
    <div class="flex items-center gap-2">
      <p-select
        [options]="allClients"
        [(ngModel)]="selectedClientFilter"
        optionLabel="label"
        optionValue="value"
        placeholder="Filter by Client"
        [filter]="true"
        filterBy="label"
        [showClear]="true"
        appendTo="body"
        (onChange)="onClientFilterChange($event.value)"
        (onClear)="onClientFilterChange(null)"
        [style]="{'min-width': '200px'}">
      </p-select>
    </div>

    <!-- SEARCH BAR -->
    <div class="flex items-center gap-2 border rounded-lg px-3 py-2 bg-white">
      <i class="pi pi-search text-gray-500"></i>
      <input 
        pInputText 
        placeholder="Search packages..." 
        class="outline-none border-none p-0"
      />
    </div>

    <!-- ADD PACKAGE BUTTON -->
    <p-button 
      label="New Add-On" 
      icon="pi pi-plus" 
      (onClick)="openAddModal()">
    </p-button>

  </div>
</div>
    <p-table [value]="clientPackage" [rows]="rows" [totalRecords]="totalRecords"  [loading]="loading">
  
      <ng-template pTemplate="header">
        <tr>
          <th>Package ID</th>
          <th>Client Name</th>
          <th>Package Name</th>
          <th>Start Date</th>
          <th>End Date</th>
          <th>Billing Type </th>
          <th>Billing Mode </th>
          <th>Billing Cycle</th>
           <th>Reminder Before Date</th>
          <th> Grace Period</th>
          <th> Next Billing Date</th>
          <th>Cancelled At</th>
          <th>Status</th>
         
        
          <th>Action</th>
        </tr>
      </ng-template>
  
      <ng-template pTemplate="body" let-package >

        <tr>
          <td>{{package.package_id}}</td>
           <td>{{package?.subscription?.client?.name}}</td>
           <td>{{package?.package?.package_name}}</td>
          <td>{{package.current_period_start | date:'dd/MM/yyyy'}}</td>
           <td>{{ package.current_period_end ? (package.current_period_end | date:'dd/MM/yyyy') : 'N/A' }}</td>
          <td>{{package.billing_type}}</td>
          <td>{{package.billing_mode}}</td>
          <td>{{package.billing_cycle}}</td>
          <td>{{package.reminder_before_days}}</td>
          <td>{{package.grace_period_days}}</td>
          <td>
           {{package.next_billing_at | date:'dd/MM/yyyy'}}
          </td>
          <td>
           {{package.cancelled_at ? (package.cancelled_at | date:'dd/MM/yyyy') : 'N/A' }}
          </td>
          <td>
           {{package.status}}
          </td>
         
         <td class="text-center">
  <p-button
    icon="pi pi-ellipsis-v"
    class="p-button-text p-button-rounded"
    (onClick)="openMenu($event, package)"
  ></p-button>

  <p-menu
    #menu
    [popup]="true"
    [model]="menuItems"
    appendTo="body"
  ></p-menu>
</td>
        </tr>
      </ng-template>
  
      <ng-template pTemplate="loading">
        <tr>
          <td colspan="8" class="text-center">
            <p-progressSpinner></p-progressSpinner>
          </td>
        </tr>
      </ng-template>
  
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="8"  class="no-data-record-found">
            <p>No records found</p>
          </td>
        </tr>
      </ng-template>
    </p-table>
  
  
  </div>
  
  <ng-container *ngIf="displayAddModal">
  <p-dialog [(visible)]="displayAddModal" [modal]="true" [style]="{width: '50rem'}" styleClass="beautiful-modal" [closable]="false">
    <app-create-client-package
    (reload)="reload()" 
    [allPackages]="allPackages"
    [clientId]="clientId" (close)="displayAddModal= false"></app-create-client-package>
  </p-dialog>
  </ng-container>

   <ng-container *ngIf="displayEditModel">
  <p-dialog [(visible)]="displayEditModel" [modal]="true" [style]="{width: '50rem'}" styleClass="beautiful-modal" [closable]="false">
    <app-create-client-package
    (reload)="reload()" 
    [allPackages]="allPackages"
    [type]="'Update'"
    [clientDataToEdit]="clientDataToEdit"
    [clientId]="clientId" (close)="displayEditModel= false"></app-create-client-package>
  </p-dialog>
  </ng-container>

<ng-container *ngIf="showDeleteModal">
  <p-dialog [(visible)]="showDeleteModal" [modal]="true" [style]="{width: '40rem'}" styleClass="beautiful-modal" [closable]="false">
    <div class="flex items-center justify-center dialog-header relative">
      Delete Add-on

      <div class="absolute right-2">
        <button (click)="showDeleteModal = false" class="outline-none p-5">
          <i class="pi pi-times"></i>
        </button>
      </div>
    </div>

    <div class="dialog-content p-5">

      <div class="text-center font-medium text-lg">
        Are you sure you want to delete the add-on:
        <span class="font-bold text-red-500">
          {{ clientDataToEdit.id }}?
        </span>
      </div>

      <div class="flex gap-4 mt-7 justify-end">
        <p-button label="Cancel" severity="secondary" variant="outlined" (click)="showDeleteModal = false">
        </p-button>

        <p-button label="Delete" severity="danger" icon="pi pi-trash" (click)="deleteAddonConfirm()" [loading]="isDeleting"
          [disabled]="isDeleting">
        </p-button>
      </div>

    </div>

  </p-dialog>
</ng-container>

<p-dialog
  header="Billing & Invoices"
  [(visible)]="invoiceModalVisible"
  [modal]="true"
  [style]="{ width: '1024px' }"
  [draggable]="false"
  [closable]="true"
  [dismissableMask]="true"
  appendTo="body"
  styleClass="beautiful-modal"
  (onHide)="handleClose()"
>

  <!-- Header Action Bar -->
  <div class="p-5 flex justify-between items-center w-full">
      <div class="text-lg font-semibold">
        Billing & Invoices
      </div>
    
  </div>

  <!-- Table -->
  <p-table
    [value]="invoices"
    [loading]="loadingInvoices"
    responsiveLayout="scroll">

    <ng-template pTemplate="header">
      <tr>
        <th>Invoice No</th>
        <th>Payment ID</th>
        <th>Type</th>
        <th>Billed For</th>
        <th>Origin</th>
        <th>Status</th>
        <th>Amount</th>
        <th>Tax</th>
        <th>Total</th>
        <th>Issued On</th>
        <th style="width:140px">Actions</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-inv>
      <tr>
        <td>{{ inv.invoice_no }}</td>
         <td>{{ inv.invoice_no }}</td>

        <td>
          <span
            class="badge px-2 py-1"
            [ngClass]="{
              'badge-info': inv.invoice_type === 'PROFORMA',
              'badge-success': inv.invoice_type === 'TAX'
            }">
            {{ inv.invoice_type }}
          </span>
        </td>
        <td>{{ inv.billing_context }}</td>
        <td>{{ inv.invoice_origin }}</td>
        <td>{{ inv.status }}</td>
        
        

        <td>₹ {{ inv.amount | number:'1.2-2' }}</td>
        <td>₹ {{ (inv.invoice_type === 'PROFORMA') ? "N/A" : (inv.tax_amount   | number:'1.2-2')  }}</td>
         <td>₹ {{ (inv.invoice_type === 'PROFORMA') ? (inv.amount   | number:'1.2-2') : (inv.total_amount   | number:'1.2-2')  }}</td>
        <td>{{ inv.issued_at | date:'dd-MM-yyyy' }}</td>

        <td class="flex gap-1">
          <button
            pButton
            icon="pi pi-eye"
            class="p-button-text p-button-sm"
            (click)="viewInvoice(inv)">
          </button>

          <button
            pButton
            icon="pi pi-download"
            class="p-button-text p-button-sm"
            (click)="downloadInvoice(inv)">
          </button>

          <button
            *ngIf="inv.invoice_type === 'PROFORMA' && inv.status == 'Paid'"
            pButton
            icon="pi pi-send"
            class="p-button-text p-button-sm"
            (click)="resendInvoice(inv)">
          </button>

          

           <button
            *ngIf="inv.invoice_type === 'TAX' && inv.status == 'Paid'"
            pButton
            icon="pi pi-undo"
            class="p-button-text p-button-sm"
            (click)="fnCancelAndRefundSubscription(inv)">
          </button>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="6" class="text-center text-gray-500 py-4">
          No invoices found
        </td>
      </tr>
    </ng-template>

  </p-table>
</p-dialog>

<p-toast position="top-right"></p-toast>

<p-dialog
  header="Send Proforma Invoice"
  [(visible)]="showProformaModal"
  [modal]="true"
  [closable]="false"
  styleClass="beautiful-modal"
  [dismissableMask]="false"
  appendTo="body"
  [style]="{ width: '28rem' }"
>
  <div class="flex flex-col gap-4 pt-2 m-4">
    <!-- Message -->
    <p class="text-sm text-surface-700">
      Are you sure you want to send the <strong>Proforma Invoice</strong> to the customer?
    </p>



    <!-- Actions -->
    <div class="flex justify-end gap-2 pt-2">
      <button
        pButton
        label="Cancel"
        class="p-button-text"
        (click)="handleClose()"
      ></button>

      <button
        pButton
        label="Send Invoice"
        icon="pi pi-send"
        class="p-button-primary"
        [disabled]="invoiceBtnLoading"
        (click)="this.generateBill(this.selectedPackage)"
      ></button>
    </div>
  </div>
</p-dialog>




<p-dialog
  header="Upgrade Package"
  [(visible)]="showUpdateModal"
  [modal]="true"
  [closable]="false"
  [style]="{ width: '30rem' }"
  styleClass="beautiful-modal"
  appendTo="body"
>
  <div class="flex flex-col gap-4 pt-2 m-4">
    
    <!-- Current Package Info -->
    <div class="bg-gray-50 p-3 rounded-md border border-gray-200">
      <div class="text-xs text-gray-500 uppercase font-semibold">Current Package</div>
      <div class="font-medium text-gray-800">{{ selectedPackage?.package?.package_name || 'N/A' }} <span class="text-gray-500">({{ selectedPackage?.billing_cycle || 'N/A' }})</span></div>
      <div class="font-medium text-gray-800">{{ selectedPackage?.package?.price || 'N/A' }}</div>
    </div>

    <!-- New Package Selection -->
    <div class="flex flex-col gap-2">
      <label class="font-medium text-gray-700">Select New Package</label>
      <p-dropdown
        [options]="upgradeablePackages"
        [(ngModel)]="newSelectedPackage"
        optionLabel="package_name"
        placeholder="Choose a package"
        [style]="{'width':'100%'}"
        appendTo="body">
        
        <ng-template pTemplate="selectedItem" let-selectedOption>
          <div class="flex justify-between items-center w-full" *ngIf="selectedOption">
            <span>{{ selectedOption.package_name }}</span>
          </div>
        </ng-template>

        <ng-template let-pkg pTemplate="item">
          <div class="flex justify-between items-center w-full gap-2">
            <span>{{ pkg.package_name }}</span>
            <span class="font-semibold text-primary ml-auto">₹{{ pkg.price || pkg.amount || 0 }}</span>
          </div>
        </ng-template>
      </p-dropdown>
    </div>

    <!-- Selected Package Price Preview -->
    <div *ngIf="newSelectedPackage" class="flex justify-between items-center p-3 bg-blue-50 text-blue-800 rounded-md border border-blue-100">
      <span class="font-medium">New Price:</span>
      <span class="font-bold text-lg">₹{{ newSelectedPackage.price || newSelectedPackage.amount || 0 }}</span>
    </div>

    <!-- Actions -->
    <div class="flex justify-end gap-2 mt-4">
      <button
        pButton
        label="Cancel"
        class="p-button-text"
        (click)="handleClose()"
      ></button>

      <button
        pButton
        label="Upgrade Package"
        icon="pi pi-arrow-circle-up"
        class="p-button-primary"
        [disabled]="!newSelectedPackage ||invoiceBtnLoading"
        [loading]="invoiceBtnLoading"
        (click)="upgradePackage()"
      ></button>
    </div>
  </div>
</p-dialog>
